import {IRoutableModule} from '../../router/routing.infra';
import {ChangePasswordView} from './change-password.view';
import {changePasswordRouteLoader} from './change-password.loader';

export default {
    loader: changePasswordRouteLoader,
    Component: ChangePasswordView,
    storeAs: 'changePasswordStore'
} as IRoutableModule;
